(function() {
  function getTierTable() {
    var table = null;
    document.querySelectorAll('table').forEach(function(t) {
      var cap = t.querySelector('caption');
      if (cap && cap.textContent.trim() === 'Volume Discounts') table = t;
    });
    return table;
  }

  function getSpotFromTicker() {
    var tickerEl = document.querySelector('#30b01ba1-acb8-4f99-af2f-900e573d965e');
    if (!tickerEl) return null;
    var symbols = tickerEl.querySelectorAll('.symbol');
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].textContent.trim() === 'Silver') {
        var valueEl = symbols[i].parentElement.querySelector('.value');
        if (valueEl) {
          var val = parseFloat(valueEl.textContent.replace(/[^0-9.]/g, ''));
          if (val > 0) return val;
        }
      }
    }
    return null;
  }

  function reverseTierRows(table) {
    var tbody = table.querySelector('tbody');
    if (!tbody || tbody.dataset.reversed) return;
    var rows = Array.from(tbody.querySelectorAll('tr'));
    rows.reverse().forEach(function(row) { tbody.appendChild(row); });
    tbody.dataset.reversed = 'true';
  }

  function injectAsLowAs(table) {
    var amountEl = document.querySelector('span.amount');
    if (!amountEl) return;
    var ins = amountEl.parentNode;
    if (!ins) return;

    var prices = [];
    table.querySelectorAll('tbody tr').forEach(function(row) {
      var cells = row.querySelectorAll('td');
      if (cells.length >= 2) {
        var val = parseFloat(cells[cells.length - 1].textContent.replace(/[^0-9.]/g, ''));
        if (val > 0) prices.push(val);
      }
    });
    if (!prices.length) return;

    var lowest = Math.min.apply(null, prices);
    var label = 'As low as $' + lowest.toFixed(2);

    var existing = document.querySelector('#xenia-as-low-as');
    if (existing) {
      if (existing.textContent !== label) existing.textContent = label;
      return lowest;
    }

    var el = document.createElement('div');
    el.id = 'xenia-as-low-as';
    el.style = 'display:block;font-size:16px;color:#666;margin-bottom:6px;';
    el.textContent = label;
    ins.parentNode.parentNode.insertBefore(el, ins.parentNode);
    return lowest;
  }

  function injectOverSpot(lowest) {
    if (document.querySelector('#xenia-over-spot')) return;
    var asLowAs = document.querySelector('#xenia-as-low-as');
    if (!asLowAs || !lowest) return;

    var spot = getSpotFromTicker();
    if (!spot) return;

    var overSpot = (lowest - spot).toFixed(2);
    var div = document.createElement('div');
    div.id = 'xenia-over-spot';
    div.style = 'display:block;font-size:16px;color:#666;margin-top:2px;margin-bottom:6px;';
    div.textContent = 'As low as $' + overSpot + ' per oz above spot';
    asLowAs.parentNode.insertBefore(div, asLowAs.nextSibling);
  }

  function runAllFixes() {
    var table = getTierTable();
    if (!table) return;
    reverseTierRows(table);
    var lowest = injectAsLowAs(table);
    injectOverSpot(lowest);
  }

  var observer = new MutationObserver(runAllFixes);
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', runAllFixes);
  runAllFixes();

  setTimeout(runAllFixes, 3000);
  setTimeout(runAllFixes, 6000);
})();